import http from '../util/request.js'

export const storeStatistics = (params) =>{
	return http({
		url:'/apistore/home/statistics',
		data:params,
		method:'get'
	})
}

export const getStoreInfo = (params) =>{
	return http({
		url:'/apistore/home/getStoreInfo',
		data:params,
		method:'get'
	})
}


export const dayStatistics = (params) =>{
	return http({
		url:'/apistore/home/dayStatistics',
		data:params,
		method:'get'
	})
}

export const getNextLevel = (params) =>{
	return http({
		url:'/apistore/home/getNextLevel',
		data:params,
		method:'post'
	})
}
export const intowallet = () =>{
	return http({
		url:'/apistore/home/intowallet',
		method:'get'
	})
}
export const storeDetail = (params) =>{
	return http({
		url:'/apistore/home/getStoreDetail',
		data:params,
		method:'get'
	})
}
export const passwordUpdate = (params) =>{
	return http({
		url:'/apistore/home/updateStorePayPassword',
		data:params,
		method:'post'
	})
}

export const updateStoreBase = (params) =>{
	return http({
		url:'/apistore/home/updateStoreBase',
		data:params,
		method:'post'
	})
}

export const updateStoreBanner = (params) =>{
	return http({
		url:'/apistore/home/updateStoreBanner',
		data:params,
		method:'post'
	})
}

export const updateStoreContact = (params) =>{
	return http({
		url:'/apistore/home/updateStoreContact',
		data:params,
		method:'post'
	})
}


export const updateStoreEmail = (params) =>{
	return http({
		url:'/apistore/home/updateStoreEmail',
		data:params,
		method:'post'
	})
}

export const updateStoreAccount = (params) =>{
	return http({
		url:'/apistore/home/updateStoreAccount',
		data:params,
		method:'post'
	})
}

export const updateStoreInfo = (params) =>{
	return http({
		url:'/apistore/home/updateStoreInfo',
		data:params,
		method:'post'
	})
}

export const uploadFile = (params) =>{

	return http({
		url: '/apistore/upload/uploadfile',
		data:params,
		method:'post',
		config:'formData'
	})
}

export const traffic = (params) =>{
	return http({
		url:'/apistore/home/traffic',
		data:params,
		method:'get'
	})
}
export const querySfType = (params) =>{
	return http({
		url:'/apistore/home/querySfType',
		data:params,
		method:'get'
	})
}
export const addIds = (params) =>{
	return http({
		url:'/apistore/home/addIds',
		data:params,
		method:'get'
	})
}
export const queryIdCardSta = (params) =>{
	return http({
		url:'/apistore/home/queryIdCardSta',
		data:params,
		method:'get'
	})
}
